import { useNavigate } from 'react-router-dom'
import { SubmitHandler } from 'react-hook-form'

import useSession from '../hooks/useSession'
import useMsgs from '@/gf/hooks/useMsgs'
import useCreateProduct from '../hooks/useCreateProduct'

import Page from '@/gf/components/Page'
import CreateProductForm from '@/gf/components/CreateProductForm'
import Frame from '../components/Frame'

import { ProductForm } from '../../types'

const breadcrumbs = {
  copy: 'Back to Dashboard',
  crumbs: [
    { name: 'Products', href: '/products' },
    { name: 'Create Product', href: '/products/create' },
  ],
}

const CreateProduct = () => {
  const { store } = useSession()
  const [_msgs, msgsMgr] = useMsgs()
  const navigate = useNavigate()
  const createProduct = useCreateProduct()

  const onSubmit: SubmitHandler<ProductForm> = (data) => {
    msgsMgr.clear()

    createProduct({ data: { ...data, storeId: store.id } })
      .then((response) => {
        const id = response?.data?.createProduct?.id
        if (id) navigate(`/products/${id}`)
        msgsMgr.add('Product saved 👍', 'positive')
      })
      .catch((errors) => {
        if (Array.isArray(errors)) {
          errors.forEach(({ attribute, message }) => {
            msgsMgr.add(`${attribute} ${message}`, 'negative')
          })
        } else {
          msgsMgr.add('Whoops, something went wrong. Please contact support.', 'negative')
        }
      })
  }

  return (
    <Frame breadcrumbs={breadcrumbs}>
      <Page title="Create Product">
        <CreateProductForm onSubmit={onSubmit} />
      </Page>
    </Frame>
  )
}

export default CreateProduct
